import { PerformanceStatus } from './PerformanceSection.types';
import { SxProps, YodaColors, YodaFontSize, YodaFontWeight, YodaSpacing } from 'yoda-ui/yodaTheme';

export const performanceSectionStyles: SxProps = {
  marginTop: YodaSpacing.medium,
  paddingTop: YodaSpacing.medium,
  paddingLeft: YodaSpacing.small,
  paddingRight: YodaSpacing.small,
  paddingBottom: YodaSpacing.small,
  borderTop: `1px solid ${YodaColors.gray1}`,
};

export const performanceTitleStyles: SxProps = {
  fontSize: YodaFontSize.medium,
  fontWeight: YodaFontWeight.medium,
  color: YodaColors.textPrimary,
  marginBottom: YodaSpacing.small,
};

export const performanceGridStyles: SxProps = {
  display: 'grid',
  gridTemplateColumns: 'repeat(6, 1fr)',
  gap: YodaSpacing.small,
  rowGap: YodaSpacing.medium,
};

export const performanceItemStyles: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: YodaSpacing.xxSmall,
};

export const performanceHeaderCellStyles: SxProps = {
  fontSize: YodaFontSize.xxSmall,
  fontWeight: YodaFontWeight.medium,
  color: YodaColors.textSecondary,
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  textAlign: 'center',
};

const getStatusColor = (status: PerformanceStatus): string => {
  switch (status) {
    case PerformanceStatus.success:
      return YodaColors.completed;
    case PerformanceStatus.failed:
      return YodaColors.error;
    case PerformanceStatus.pending:
      return YodaColors.warning;
    case PerformanceStatus.na:
    default:
      return YodaColors.gray3;
  }
};

export const statusBadgeStyles = (status: PerformanceStatus): SxProps => ({
  display: 'inline-block',
  fontSize: YodaFontSize.xSmall,
  fontWeight: YodaFontWeight.medium,
  color: getStatusColor(status),
  backgroundColor: status === PerformanceStatus.success
    ? YodaColors.greenSuccessLight
    : status === PerformanceStatus.failed
      ? YodaColors.redErrorLight
      : status === PerformanceStatus.pending
        ? YodaColors.warningLight
        : YodaColors.gray1,
  borderRadius: '4px',
  padding: '4px 12px',
  textAlign: 'center',
  minWidth: '40px',
});
